import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, mobileOrderButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/EB40gNROlntCgG4Gu4ep/locations/nbPAp9IRMwwyqtP2dwMx`}
            >
              <CFView hover>
                <CFImage
                  src={mobileOrderButton}
                  w="75%"
                  maxnWidth="320px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/EB40gNROlntCgG4Gu4ep/locations/nbPAp9IRMwwyqtP2dwMx`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="210px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
